import { render, staticRenderFns } from "./data-empty.vue?vue&type=template&id=20451d12&scoped=true&"
import script from "./data-empty.vue?vue&type=script&lang=ts&"
export * from "./data-empty.vue?vue&type=script&lang=ts&"
import style0 from "./data-empty.vue?vue&type=style&index=0&id=20451d12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20451d12",
  null
  
)

export default component.exports